<template>
  <div id="app">
    <header-bar></header-bar>
    <menu-bar
      :activeIndex="firstActiveIndex"
      :firstMenu="firstMenuMutation"
      v-on:activeIndexBychild="activeIndexBychild"
    ></menu-bar>
    <div :class="screen === 'phone' ? 'container phone-containner' : 'container'">
      <div class="right-box">
        <div class="content">
          <router-view :key="fullPath + activeIndexBychild.firstClassId"></router-view>
        </div>
      </div>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import headerBar from '../components/header';
import footerBar from '../components/footer';
import menuBar from '../components/menu';
import { mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      fullPath: this.$router.path,
      routerKey: this.$router.key,
      routerName: this.$route.name,
      activeIndex: this.$route.params.activeIndex || '0',
      // firstId: this.$route.params.id,

      firstActiveIndex: this.$route.params.firstActiveIndex || '0',
      firstId: this.$route.params.firstId,
      secondActiveIndex: this.$route.params.secondActiveIndex,
      secondId: this.$route.params.secondId,
      thirdActiveIndex: this.$route.params.thirdActiveIndex,
      thirdId: this.$route.params.thirdId,
      firstMenu: [],
      secondMenu: [],
      thirdMenu: [],
      firstMenuMap: {},
      secondMenuMap: {},
      thirdMenuMap: {},

      menuDataList: [],
      // secondActiveIndex: this.$route.params.secondActiveIndex || '0',
      // secondId: this.$route.params.secondId,
      articleId: this.$route.params.articleId,
    };
  },
  components: {
    headerBar,
    menuBar,
    footerBar,
  },
  computed: {
    ...mapGetters([
      'screen',
      'firstMenuMutation',
      'firstMenuMapMutation',
      'secondMenuMutation',
      'secondMenuMapMutation',
      'thirdMenuMutation',
      'thirdMenuMapMutation',
    ]),
  },
  created() {
    Promise.all([
      this.menuListNoPagination({ level: 1 }),
      this.menuListNoPagination({ level: 2 }),
      this.menuListNoPagination({ level: 3 }),
    ])
      .then((res) => {
        const [firstMenu, secondMenu, thirdMenu] = res;
        if (res.success) {
          // 1级
          this.firstMenu = firstMenu.data;
          this.firstMenu.map((item) => {
            this.firstMenuMap[item.id] = item;
          });
          this.$store.commit('firstMenuMapMutation', this.firstMenuMap);
          // 2级
          this.secondMenu = secondMenu.data;
          this.secondMenu.map((item) => {
            this.secondMenuMap[item.id] = item;
          });
          this.$store.commit('secondMenuMapMutation', this.secondMenuMap);
          // 3级
          this.thirdMenu = thirdMenu.data;
          this.thirdMenu.map((item) => {
            this.thirdMenuMap[item.id] = item;
          });
          this.$store.commit('thirdMenuMapMutation', this.thirdMenuMap);
        }
      })
      .catch((e) => {
        this.$message.error(e);
      });
    // this.menuListNoPagination({level: 1}).then(res => {
    //   if (res.success) {
    //     this.firstMenu = res.data;
    //   }
    // })
  },
  watch: {
    $route(to, from) {
      this.firstActiveIndex = this.$route.params.firstActiveIndex;
      this.firstId = this.$route.params.firstId;
      this.secondActiveIndex = this.$route.params.secondActiveIndex;
      this.secondId = this.$route.params.secondId;
      console.log(this.firstId, this.firstMenuMutation, this.articleId, 'aaaaaaa======');
      console.log(to, from, 'aaaaaa=====bbb');
      if (!this.firstId && !to.params.articleId) {
        if (this.firstMenuMutation.length === 0) {
          this.menuListNoPagination({ level: 1 }).then(res => {
            if (res.success) {
              this.activeIndexBychild({
                firstActiveIndex: '0',
                firstClassId: res.data[0].id
              })
            }
          })
        } else {
          this.activeIndexBychild({
            firstActiveIndex: '0',
            firstClassId: this.firstMenuMutation[0].id
          });
        }
      }
    },
  },
  methods: {
    ...mapActions(['menuListNoPagination', 'menuIdContent']),
    activeIndexBychild(obj) {
      console.log(obj, 'obj')
      this.firstActiveIndex = obj.firstActiveIndex;
      this.firstId = obj.firstClassId;
      this.getContent(this.firstId, this.firstActiveIndex);
    },
    getContent(idValue, activeIndex) {
      this.menuIdContent({ id: idValue })
        .then((res) => {
          console.log(res, '一级导航切换');
          if (res.success) {
            if (res.data.styleType === -1) {
              // 到二级导航
              this.$router.push(
                `/class/first/${activeIndex}/${idValue}/second/0/${res.data.data[0].id}`,
              );
            } else if (res.data.styleType === 'IMAGE_TXT') {
              // 到一级导航
              this.$router.push(
                `/menu/first/${activeIndex}/${idValue}`,
              );
            } else if (res.data.styleType === 1 || res.data.styleType === 2) {
               // 到一级导航
              this.$router.push(
                `/menu/first/${activeIndex}/${idValue}`,
              );
            } else {
                // 到一级导航
              this.$router.push(
                `/menu/first/${activeIndex}/${idValue}`,
              );
            }
          } else {
            this.$message({
              message: res.msg || '服务开小差',
              type: 'warning',
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: '服务器出错啦',
            type: 'error',
          });
        });
    },
  },
};
</script>

<style lang="less">
.container {
  // height: calc(100% - 1.8rem);
  min-height: 8rem;
  margin: 0 auto;
  padding: 0 7.5%;
  display: flex;
  font-size: 0.3rem;
  .right-box {
    height: 100%;
    width: 100%;
    .content {
      padding: 0.2rem;
      background-color: #fff;
    }
  }
  .bread-box {
    margin: 0.3rem 0;
    font-size: 0.26rem;
  }
}
.phone-containner {
  padding: 0;
}
</style>
